export default "__VITE_ASSET__DuizDBtV__"